import { buildManualWorkOrderPrintJobDeliveryDownloadUrl } from "../../../../../../../../../../../../../../api/kehrblatt/letters"

import { ApiError } from "../../../../../../../../../../../../../../api/kehrblatt/client"
import {
  fetchDownloadBlob,
  triggerObjectUrlDownload,
} from "../../../../../../../../../../../../_shared/_logic/object-url-download"
import {
  LetterPrintSelectionExpiredError,
  type DownloadLetterPrintJobOperations,
} from "../../actions/downloadLetterPrintJob"

export const downloadLetterPrintJobOperations: DownloadLetterPrintJobOperations = {
  downloadPrintJob: async ({ jobId, organizationId }) => {
    let objectUrl: string | null = null
    try {
      const download = await fetchDownloadBlob(
        buildManualWorkOrderPrintJobDeliveryDownloadUrl(jobId, organizationId),
        "Terminbriefe_händische_Zustellung.pdf",
      )
      objectUrl = download.objectUrl
      triggerObjectUrlDownload(download)

      return { filename: download.filename, deliveryCompleted: false }
    } catch (error) {
      if (error instanceof ApiError && (error.status === 409 || error.status === 404)) {
        throw new LetterPrintSelectionExpiredError()
      }

      throw error
    } finally {
      if (objectUrl) window.setTimeout(() => URL.revokeObjectURL(objectUrl), 0)
    }
  },
}
